import { getVariantSourceSellerInfo } from "../../../utils/sourceSellerHelper";

export const shouldIncludeFlexibleSalesChannels = (variant) => {
  const { isPartnerFulfils, isAsosFulfils } =
    getVariantSourceSellerInfo(variant);
  return isPartnerFulfils || isAsosFulfils;
};

export const addFlexibleSalesChannels = (variant) => {
  const { source, seller } = variant;

  const sourceId = source?.id ?? null;
  const sellerId = seller?.id ?? null;

  return {
    sourceId,
    sellerId,
  };
};
